import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/mercedes-benz-gebraucht/")({
  head: () => routeHead("/de/mercedes-benz-gebraucht/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/cars/mercedes-benz", statusCode: 301, replace: true });
  },
});
